import { Outlet } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Header } from '../components/App/MainPage/Header/Header';
import { Footer } from '../components/App/MainPage/Footer/Footer';
import { theme } from '../theme';

export default function MainLayout() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <div
        style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
      >
        <Header />
        <div style={{ flex: 1 }}>
          <Outlet />
        </div>
        <Footer />
      </div>
    </ThemeProvider>
  );
}
